import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NotificationState {
  message: React.ReactNode;
  type: 'success' | 'error' | 'loading';
  visible: boolean;
}

const initialState: NotificationState = {
  message: '',
  type: 'success',
  visible: false,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<{ message: React.ReactNode, type: 'success' | 'error' | 'loading' }>) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.visible = true;
    },
    hideNotification: (state) => {
      state.visible = false;
    },
  },
});

export const { showNotification, hideNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
